module.exports = __webpack_public_path__ + "img/eluard.f4f85303.jpg";